module.exports = __webpack_public_path__ + "static/media/test7_4.b7968a12.png";